<template>
  <div v-if="loaded" style="width:100%;">
    <v-tabs v-model="tab" grow>
      <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <div class="mb-4 pa-5">
          <line-chart :data="subscriberList" :label="label" height="1800px"></line-chart>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="mb-4 pa-5">
          <line-chart :data="viewList" :label="label" height="1800px"></line-chart>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="mb-4 pa-5">
          <line-chart :data="videoList" :label="label" height="1800px"></line-chart>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import ApiService from "../common/api.service";
import LineChart from "../components/chart/LineChart";

export default {
  name: "Analysis",
  label: String,
  data() {
    return {
      subscriberList: [],
      viewList: [],
      videoList: [],
      loaded: false,
      tab: null,
      items: ["登録者推移", "再生数推移", "投稿数推移"],
      bgColors: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)"
      ],
      bdColors: [
        "rgba(255, 99, 132, 1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)"
      ],
      useBgColors: [],
      useBdColors: []
    };
  },
  components: {
    LineChart
  },
  async mounted() {
    this.label = "登録者";
    this.subscriberList = await this.getSubscriberData();
    this.setGraphBgColor(this.subscriberList);
    this.viewList = await this.getViewsData();
    this.setGraphBgColor(this.viewList);
    this.videoList = await this.getVideosData();
    this.setGraphBgColor(this.videoList);
    this.loaded = true;
  },
  methods: {
    // チャンネル登録数取得
    getSubscriberData: async function() {
      const dataList = {
        labels: [],
        datasets: [
          {
            data: [],
            borderWidth: 1,
            backgroundColor: this.useBgColors,
            borderColor: this.useBdColors
          }
        ]
      };
      await ApiService.get("aggregate/subscriber").then(res => {
        const result = res.data.result
        dataList.labels = result.map(v => {
          return v.title;
        });
        dataList.datasets[0].data = result.map(v => {
          return v.subscriber_count;
        });
      });
      return dataList;
    },
    // チャンネル閲覧数取得
    getViewsData: async function() {
      const dataList = {
        labels: [],
        datasets: [
          {
            data: [],
            borderWidth: 1,
            backgroundColor: this.useBgColors,
            borderColor: this.useBdColors
          }
        ]
      };
      await ApiService.get("aggregate/views").then(res => {
        const result = res.data.result
        dataList.labels = result.map(v => {
          return v.title;
        });
        dataList.datasets[0].data = result.map(v => {
          return v.view_count;
        });
      });
      return dataList;
    },
    // 投稿数取得
    getVideosData: async function() {
      const dataList = {
        labels: [],
        fontColor: "white",
        datasets: [
          {
            data: [],
            borderWidth: 1,
            backgroundColor: this.useBgColors,
            borderColor: this.useBdColors
          }
        ]
      };
      await ApiService.get("aggregate/videos").then(res => {
        const result = res.data.result
        dataList.labels = result.map(v => {
          return v.title;
        });
        dataList.datasets[0].data = result.map(v => {
          return v.video_count;
        });
      });
      return dataList;
    },
    setGraphBgColor: function(dataList) {
      this.backgroundColor;
      const loopCount = Math.floor(dataList.labels.length / this.bgColors.length);
      for (let i = 0; i < loopCount; i++) {
        this.bgColors.forEach(v => {
          this.useBgColors.push(v);
        });
        this.bdColors.forEach(v => {
          this.useBdColors.push(v);
        });
      }
    }
  },
  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.aaa {
  height: 1800px;
}
</style>
